import { render, staticRenderFns } from "./ConferencesRoot.vue?vue&type=template&id=24b615af"
import script from "./ConferencesRoot.vue?vue&type=script&lang=js"
export * from "./ConferencesRoot.vue?vue&type=script&lang=js"
import style0 from "./ConferencesRoot.vue?vue&type=style&index=0&id=24b615af&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b615af')) {
      api.createRecord('24b615af', component.options)
    } else {
      api.reload('24b615af', component.options)
    }
    module.hot.accept("./ConferencesRoot.vue?vue&type=template&id=24b615af", function () {
      api.rerender('24b615af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/ConferencesRoot.vue"
export default component.exports